import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useAuthContext } from "./useAuthContext";

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies(null, { path: "/" });

  const login = async (username, password) => {
    setIsLoading(true);
    setError(null);

    if (!username || !password) {
      setIsLoading(false);
      let errorMessage = "";
      if (!username) errorMessage += "Upišite korisničko ime. ";
      if (!password) errorMessage += "Upišite zaporku.";
      setError(errorMessage);
      return;
    }

    if (!username.endsWith("@fesb.hr") && !username.endsWith("@ad.fesb.hr")) {
      setIsLoading(false);
      setError("Korisničko ime mora završavati sa @fesb.hr");
      return;
    }

    try {
      const response = await fetch("/api/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const json = await response.json();

      if (!response.ok) {
        setIsLoading(false);
        setError(json.error);
        return;
      }

      const { userId, token, isAdmin, isModerator, fullName } = json;
      cookies.set("token", token, { path: "/" });
      cookies.set("username", username, { path: "/" });
      cookies.set("userId", userId, { path: "/" });
      cookies.set("isAdmin", isAdmin, { path: "/" });
      cookies.set("isModerator", isModerator, { path: "/" });
      cookies.set("fullName", fullName, { path: "/" });

      dispatch({
        type: "LOGIN",
        payload: { username, token, isAdmin, isModerator, fullName },
      });

      setIsLoading(false);
      if (location.pathname === "/") navigate("/FirstInput");
    } catch (error) {
      setIsLoading(false);
      setError("Dogodila se greška prilikom prijave. Pokušajte ponovno.");
    }
  };

  return { login, isLoading, error };
};
